import React from 'react';
import { RadioLabel } from '@weezevent/nacre';
import InventorySelector from './InventorySelector';
import { useTranslation } from 'react-i18next';

export default function ModeSelector({ mode, setMode, onOpenInventory, onSelectInventory, inventories, form }) {
    const { t } = useTranslation();

    const handleChange = React.useCallback(
        e => {
            setMode(!mode);
        },
        [setMode, mode]
    );

    return (
        <>
            <RadioLabel className="radio-label-custom" name="availability_display" value="manual" checked={!mode} inline bordered onChange={handleChange}>
                {t('attendees.addAttendees.withSeats.manual')}
            </RadioLabel>
            <RadioLabel className="radio-label-custom" name="availability_display" value="automatic" checked={mode} inline bordered onChange={handleChange}>
                {t('attendees.addAttendees.withSeats.auto')}
            </RadioLabel>

            {mode && (
                <InventorySelector
                    title={t('attendees.addAttendees.withSeats.selectLabel')}
                    onOpen={onOpenInventory}
                    onChange={onSelectInventory}
                    form={form}
                    inventories={inventories}
                />
            )}
        </>
    );
}
